// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as TabsPrimitive from '@radix-ui/react-tabs';
import clsx from 'clsx';
import { withClassName } from '../../hooks/withClassName.js';
export const TabsRoot = withClassName(TabsPrimitive.Root, '');
export const TabsList = withClassName(TabsPrimitive.List, 'flex flex-row flex-wrap py-2 px-2 items-start gap-2');
export const TabsTriggerBase = withClassName(TabsPrimitive.Trigger, 'layer-components:flex layer-components:flex-row layer-components:items-center layer-components:cursor-pointer layer-components:justify-center layer-components:gap-2 layer-components:color-black layer-components:py-1 layer-components:px-5 layer-components:bg-wash layer-components:text-md layer-components:min-w-100px layer-components:rounded-lg layer-components:border-default layer-components:font-semibold layer-components:text-gray-dark-blend layer-components:border-gray-dark layer-components:transition-all layer-components:cursor-pointer layer-components:select-none layer-components:font-inherit layer-components:flex-shrink-0 layer-components:shadow-sm', 'layer-components:hover:bg-darken-1 layer-components:hover:ring-4 layer-components:hover:ring-bg', 'layer-components:focus-visible:bg-darken-3 layer-components:focus-visible:ring-6 layer-components:focus-visible:ring-bg layer-components:focus-visible:outline-off', '[&[data-state=active]]:bg-[var(--bg)] [&[data-state=active]]:font-semibold [&[data-state=active]]:text-black [&[data-state=active]]:cursor-default [&[data-state=active]]:hover:bg-darken-1 [&[data-state=active]]:relative [&[data-state=active]]:z-1');
const colorClasses = {
    default: 'layer-variants:[--bg:var(--color-white)]',
    primary: 'layer-variants:[--bg:var(--color-primary)]',
};
export const TabsTrigger = (_a) => {
    var { className, color = 'primary' } = _a, props = __rest(_a, ["className", "color"]);
    return (_jsx(TabsTriggerBase, Object.assign({ className: clsx(colorClasses[color], `btn-color-${color}`, className) }, props)));
};
export const TabsContent = withClassName(TabsPrimitive.Content, '');
export const Tabs = Object.assign(TabsRoot, {
    List: TabsList,
    Trigger: TabsTrigger,
    Content: TabsContent,
});
//# sourceMappingURL=tabs.js.map